import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import Header4 from "./../Common/Header4"
import Footer from "./../Common/Footer"
import Banner from "./../Elements/Banner"
import ReactPlayer from "react-player"
import { useLocation } from "react-router-dom"

const bnrimg = require("./../../images/banner/4.jpg")

const ServiceDetail = () => {
  const location = useLocation()
  const [arch, setArch] = useState(location.hash)

  return (
    <>
      <Header4 />
      <div className="page-content">
        <Banner
          title="SERVICE DETAILS"
          pagename="Service Detail"
          description="Each service is tailored to fit your needs — combining thoughtful design, quality execution, and a clear vision for your space."
          bgimage={bnrimg}
        />

        {/* SECTION CONTENT START */}
        <div className="section-full p-t80 p-b50 mobile-page-padding">
          <div className="container">
            {/* GALLERY CONTENT START */}
            <div className="row">
              <div className="col-lg-4 col-md-12 sticky_column">
                <div className="about4-section m-b20 bg-white p-a20">
                  <div className="widget widget_services">
                    <h4 className="widget-title">More Services</h4>
                    <ul className="bg-white" style={{ fontWeight: "700" }}>
                      <li>
                        <div
                          onClick={(e) => {
                            setArch("#0")
                          }}
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#0" ? "#574136" : "#000"}`,
                          }}
                        >
                          Plans And Projects
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#1" ? "#574136" : "#000"}`,
                          }}
                          onClick={(e) => {
                            setArch("#1")
                          }}
                        >
                          Interior
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#2" ? "#574136" : "#000"}`,
                          }}
                          onClick={(e) => {
                            setArch("#2")
                          }}
                        >
                          Exterior
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#3" ? "#574136" : "#000"}`,
                          }}
                          onClick={(e) => {
                            setArch("#3")
                          }}
                        >
                          Architecture
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#4" ? "#574136" : "#000"}`,
                          }}
                          onClick={(e) => {
                            setArch("#4")
                          }}
                        >
                          Furniture
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#5" ? "#574136" : "#000"}`,
                          }}
                          onClick={(e) => {
                            setArch("#5")
                          }}
                        >
                          Decoration
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            cursor: "pointer",
                            color: `${arch === "#6" ? "#574136" : "#000"}`,
                          }}
                          onClick={(e) => {
                            setArch("#6")
                          }}
                        >
                          BIM
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                    <NavLink to="/services-1" className="btn-block">
                      <span className="text-black m-r10">
                        <i className="fa fa-file-pdf-o" />
                      </span>
                      <strong className="text-uppercase text-black">
                        Download .PDF
                      </strong>
                    </NavLink>
                  </div> */}
                  {/* <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                    <NavLink to="/services-1" className="btn-block">
                      <span className="text-black m-r10">
                        <i className="fa fa-file-word-o" />
                      </span>
                      <strong className="text-uppercase text-black">
                        Download .DOC
                      </strong>
                    </NavLink>
                  </div> */}
                  {/* <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                    <NavLink to="/services-1" className="btn-block">
                      <span className="text-black m-r10">
                        <i className="fa fa-file-powerpoint-o" />
                      </span>
                      <strong className="text-uppercase text-black">
                        Download .PPT
                      </strong>
                    </NavLink>
                  </div> */}

                  <div className="about4-content m-t30">
                    <h4>GET 10% OFF TODAY</h4>
                    {/* <p>
                      A Completely Safe and Advanced Cleaning Solution for both
                      Petrol and Diesel Engines
                    </p> */}
                    {/* <NavLink to="/services-1" className="site-button-link">
                      Read More
                    </NavLink> */}
                  </div>
                </div>
              </div>

              {arch === "#0" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/service-details/1.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Comprehensive Design Planning & Project Management
                      </h3>
                      {/* <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit...
                      </p> */}
                      <p>
                        Our interior design service brings harmony to every
                        corner of your space. We develop custom layouts, select
                        color palettes, materials, lighting, and finishes to
                        reflect your personal style. Whether you're starting
                        fresh or upgrading, we create interiors that feel
                        curated and complete.
                      </p>

                      {/* <div className="single-service-list">
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <ul className="list-angle-right anchor-line">
                              <li>
                                <NavLink to="/services-1">
                                  We provide high quality design services.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  We are confident about our projects.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  A good Work Environment For work
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Communication Skills to getting in touch
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Renovations Benefit of Service
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <ul className="list-angle-right anchor-line">
                              <li>
                                <NavLink to="/services-1">
                                  Sustainability and modern tech.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  A Career Overview opportunity Available
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Scientific Skills For getting a better result
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Historic Renovations and Restorations.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Project on time and Latest Design
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="sx-media sx-img-effect zoom-slow">
                        <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                          <img
                            src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg"
                            alt=""
                          />
                          <NavLink
                            to="#"
                            className="play-now"
                            data-toggle="modal"
                            data-target="#myModal6"
                          >
                            <i className="icon fa fa-play" />
                            <span className="ripple" />
                          </NavLink>
                        </div>
                      </div> */}
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Panel 1 - Planning and Projects */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              What does the planning phase include?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse ">
                          <div className="acod-content p-a15">
                            {/* <h5 className="m-b10"></h5> */}
                            <p>
                              It includes initial consultations, space analysis,
                              layout concepts, material suggestions, and
                              technical drawings for construction and execution.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Panel 2 - Unchanged */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you handle permits and approvals?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we assist with all necessary documentation
                              and coordination to meet regulatory requirements.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Panel 3 - Unchanged */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Can I make changes during the project?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Absolutely. We prioritize flexibility and
                              collaboration throughout the design and execution
                              process.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {arch === "#1" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/service-details/2.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Tailored Interior Spaces with Timeless Style
                      </h3>

                      <p>
                        Our interior design service brings harmony to every
                        corner of your space. We develop custom layouts, select
                        color palettes, materials, lighting, and finishes to
                        reflect your personal style. Whether you're starting
                        fresh or upgrading, we create interiors that feel
                        curated and complete.
                      </p>

                      {/* 
                      <div className="single-service-list">
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <ul className="list-angle-right anchor-line">
                              <li>
                                <NavLink to="/services-1">
                                  We provide high quality design services.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  We are confident about our projects.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  A good Work Environment For work
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Communication Skills to getting in touch
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Renovations Benefit of Service
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <ul className="list-angle-right anchor-line">
                              <li>
                                <NavLink to="/services-1">
                                  Sustainability and modern tech.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  A Career Overview opportunity Available
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Scientific Skills For getting a better result
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Historic Renovations and Restorations.
                                </NavLink>
                              </li>
                              <li>
                                <NavLink to="/services-1">
                                  Project on time and Latest Design
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="sx-media sx-img-effect zoom-slow">
                        <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                          <img
                            src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg"
                            alt=""
                          />
                          <NavLink
                            to="#"
                            className="play-now"
                            data-toggle="modal"
                            data-target="#myModal6"
                          >
                            <i className="icon fa fa-play" />
                            <span className="ripple" />
                          </NavLink>
                        </div>
                      </div> */}
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Accordion Panels */}
                      {/* Panel 1 */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you work with existing furniture or only design
                              new layouts?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse ">
                          <div className="acod-content p-a15">
                            <p>
                              We can integrate your current pieces or propose a
                              completely new concept — depending on your vision.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Panel 2 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Can you help with choosing color palettes and
                              finishes?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we offer comprehensive design direction
                              including color theory, finish selection, and
                              texture coordination.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Panel 3 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              How long does a full interior design project take?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Timelines vary based on project scope but
                              typically range from 4 to 12 weeks.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {arch === "#2" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/service-details/3.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Elegant and Functional Outdoor Living Spaces
                      </h3>

                      <p>
                        Our exterior design service transforms facades, patios,
                        and entryways into stunning outdoor experiences. Whether
                        it’s a contemporary villa or a traditional courtyard, we
                        enhance your property's curb appeal while optimizing
                        usability and outdoor comfort.
                      </p>
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Panel 1 */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you design landscaping as well?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse ">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we offer basic landscaping concepts and
                              collaborate with landscape specialists for more
                              extensive projects.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Panel 2 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              What styles do you specialize in for exteriors?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              From modern minimalist to traditional elegance, we
                              tailor the design to match your taste and
                              architectural context.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Panel 3 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Can you redesign a villa entrance or driveway?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Absolutely — we handle comprehensive exterior
                              enhancements, including driveways, lighting, and
                              curb appeal upgrades.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {arch === "#3" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/service-details/4.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Purposeful Architecture with Creative Vision
                      </h3>
                      <p>
                        Our architectural services offer thoughtful design
                        solutions for residential and commercial structures. We
                        combine modern aesthetics with environmental awareness,
                        designing buildings that stand the test of time — both
                        visually and structurally.
                      </p>
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Accordion Panels */}
                      {/* Panel 1 */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you design both residential and commercial
                              buildings?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse ">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we offer architectural solutions for homes,
                              villas, offices, and boutique commercial spaces.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 2 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you provide construction supervision?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we offer site visits and coordination with
                              contractors to ensure designs are executed
                              accurately.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 3 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Can you help with facade redesign?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Definitely — we specialize in transforming
                              outdated exteriors into modern, elegant
                              statements.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {arch === "#4" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/service-details/5.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Bespoke Furniture That Complements Your Space
                      </h3>
                      <p>
                        Our furniture design service offers curated and
                        custom-made pieces that reflect your taste and fit your
                        space perfectly. From built-ins to standalone statement
                        pieces, we focus on comfort, materials, and design
                        harmony to elevate every room.
                      </p>
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Accordion Panels */}
                      {/* Panel 1 */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Can you design custom furniture?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse ">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we specialize in bespoke furniture tailored
                              to your space, lifestyle, and aesthetic.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 2 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you only work with specific materials?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              No, we work with a wide range of materials — from
                              wood and metal to glass and textiles — based on
                              your preferences.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 3 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Is furniture design included in the full interior
                              design package?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              It can be — we offer it as a standalone service or
                              as part of a complete interior design package.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {arch === "#5" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/service-details/6.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Finishing Touches That Transform Spaces
                      </h3>
                      <p>
                        Our decoration service focuses on visual balance and
                        finishing touches. From art and lighting to curtains,
                        textiles, and styling, we enhance the mood and character
                        of each room to ensure it feels complete, curated, and
                        comfortable.
                      </p>
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Panel 1 */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Can you help with final touches only (without
                              major renovation)?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse ">
                          <div className="acod-content p-a15">
                            <p>
                              Yes — our decoration service is perfect for
                              refreshing spaces with small, impactful changes.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 2 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              What decorative elements do you provide?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              We assist with rugs, curtains, cushions, lighting
                              fixtures, wall art, and accessories.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 3 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Do you offer seasonal or event styling?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Yes, we offer styling services for special
                              occasions and seasonal updates.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {arch === "#6" && (
                <div className="col-lg-8 col-md-12 ">
                  <div className="section-content ">
                    <div className="service-single-block m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/services/service-projects/BIM1.png")}
                          alt=""
                        />
                      </div>
                      <h3 className="m-t30 sx-tilte">
                        Intelligent 3D Modeling for Smarter Projects
                      </h3>
                      <p>
                        Our BIM service supports your project with intelligent
                        3D models that enhance accuracy, coordination, and
                        speed. Ideal for both architecture and interior design,
                        BIM minimizes errors, supports collaboration, and
                        improves decision-making from design to construction.
                      </p>
                    </div>

                    <div
                      className="sx-accordion acc-bg-gray m-b30"
                      id="accordion5"
                    >
                      {/* Panel 1 */}
                      <div className="panel sx-panel">
                        <div className="acod-head ">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseOne5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              What software do you use for BIM?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseOne5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              We use industry-leading tools such as Revit,
                              AutoCAD, and Navisworks.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 2 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseTwo5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              Is BIM available for residential projects?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseTwo5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              Yes — BIM can be applied to both residential and
                              commercial designs for greater planning precision.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Panel 3 */}
                      <div className="panel sx-panel">
                        <div className="acod-head">
                          <h6 className="acod-title">
                            <a
                              data-toggle="collapse"
                              href="#collapseThree5"
                              className="collapsed"
                              data-parent="#accordion5"
                            >
                              How does BIM improve the construction process?
                              <span className="indicator">
                                <i className="fa" />
                              </span>
                            </a>
                          </h6>
                        </div>
                        <div id="collapseThree5" className="acod-body collapse">
                          <div className="acod-content p-a15">
                            <p>
                              BIM provides accurate, real-time data which
                              reduces errors, saves time, and supports better
                              collaboration among all stakeholders.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-md-12 m-b30">
                        <div className="sx-icon-box-wraper p-a30 center bg-white shadow">
                          <div className="sx-icon-box-lg inline-icon text-primary m-b20 radius bg-secondry scale-in-center">
                            <span className="icon-cell sx-text-primary">
                              <i className="flaticon-door" />
                            </span>
                          </div>
                          <div className="icon-content">
                            <h4 className="sx-tilte">Furniture</h4>
                            <p>
                              We enhance every space with carefully chosen
                              furniture pieces that reflect your style and
                              elevate the comfort and functionality.
                            </p>
                            <NavLink
                              to={`/services-detail${"#4"}`}
                              onClick={() => {
                                setArch("#4")
                              }}
                              className="site-button-link"
                            >
                              Read More
                            </NavLink>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-6 m-b30">
                        <div className="sx-icon-box-wraper p-a30 center bg-white shadow">
                          <div className="sx-icon-box-lg inline-icon text-primary m-b20 radius bg-secondry scale-in-center">
                            <span className="icon-cell sx-text-primary">
                              <i className="flaticon-ruler-1" />
                            </span>
                          </div>
                          <div className="icon-content">
                            <h4 className="sx-tilte">Solution</h4>
                            <p>
                              Lorem Ipsum is simply dummy text of the
                              printing...
                            </p>
                            <NavLink
                              to="/services-1"
                              className="site-button-link"
                            >
                              Read More
                            </NavLink>
                          </div>
                        </div>
                      </div> 
                    </div> */}
                  </div>
                </div>
              )}
            </div>
            {/* GALLERY CONTENT END */}
          </div>
        </div>
        {/* SECTION CONTENT END */}
      </div>

      <div className="modal fade" id="myModal6" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <ReactPlayer url="https://www.youtube.com/watch?v=Oy2QIiSQT2U" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default ServiceDetail
